import { render, staticRenderFns } from "./ResetPasswordPhone.vue?vue&type=template&id=28007b43&scoped=true"
import script from "./ResetPasswordPhone.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPhone.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordPhone.vue?vue&type=style&index=0&id=28007b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28007b43",
  null
  
)

export default component.exports